import React from 'react';
import { useIntl } from 'react-intl';

import Typography from '@mui/material/Typography';

import { useTheme } from '@mui/material';

const DokkaPayTitleText: React.FC = () => {
  const { formatMessage } = useIntl();
  const { palette } = useTheme();

  return (
    <Typography
      sx={{
        background: `linear-gradient(90deg, ${palette.primary.main} 0%, ${palette.secondary.main} 25%)`,
        backgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }}
    >
      {formatMessage({ id: 'company.paymentsWorkspace.title', defaultMessage: 'DOKKA PAY' })}
    </Typography>
  );
};

export default DokkaPayTitleText;
